<template>
  <section
    v-if="!isSignedIn"
    :class="[
      'flex gap-8 mr-[52px] mt-12 mb-12 ml-12 sm:m-12 rounded-lg justify-center items-center sign-up-card flex-col',
      isVonageBrand
        ? 'bg-canvas pt-0 pl-0 pr-0 pb-[22px] sm:p-[22px] lg:flex-row'
        : 'signup-banner-bg p-[22px] xl:p-0 xl:flex-row',
    ]"
  >
    <div :class="['flex basis-4/12 items-center w-full sm:w-fit', { 'justify-center': isVonageBrand }]">
      <div class="w-full sm:w-fit">
        <img
          v-if="isVonageBrand"
          src="https://s3.eu-west-1.amazonaws.com/developer.vonage.com/blog/sign_up_button/laptop.png"
          class="hidden sm:flex lg:flex w-[188.19px] h-[76px]"
          alt="sign-up-card-image"
        />
        <img
          v-else
          class="hidden xl:flex w-auto h-[130px] object-cover max-w-full"
          alt=""
          :src="getFullPathForBrandedAssets('/assets/images/documentation/getting-started.png')"
        />
        <img
          :src="getFullPathForPublicAssets('/assets/images/products/celebration.png')"
          class="w-full h-full overflow-hidden shrink-0 sm:hidden celebration-image"
          alt="celebration-image"
        />
      </div>
    </div>
    <div class="basis-4/12 pl-[22px] pr-[22px] sm:p-[0]">
      <div class="flex flex-col h-full justify-center text-section">
        <div class="sign-up-card-text-title not-italic font-semibold text-base hidden sm:flex lg:hidden">
          {{ $t('components.signUpCta.title') }}
        </div>
        <div class="sign-up-card-text-title not-italic font-semibold text-base sm:hidden">
          {{ $t('components.createFreeAccount.title') }}
        </div>
        <div class="sign-up-card-text-description not-italic font-semibold text-sm hidden sm:flex lg:flex">
          <i18n-t keypath="components.signUpCta.description" tag="span" scope="global">
            <template #vendorName>
              {{ VendorName }}
            </template>
          </i18n-t>
        </div>
        <div class="sign-up-card-text-description not-italic font-semibold text-sm sm:hidden">
          {{ $t('components.createFreeAccount.description') }}
        </div>
      </div>
    </div>
    <div class="flex basis-4/12 justify-center items-center pl-[22px] pr-[22px] sm:p-[0] vvd-theme-alternate">
      <a href="/sign-up" type="button">
        <v-button
          class="rounded-md hidden sm:flex lg:flex"
          :label="$t('components.signUpCta.button')"
          icon="user-line"
          :connotation="!isVonageBrand && 'cta'"
          :appearance="isVonageBrand ? 'filled' : 'outlined'"
          icon-trailing
        />
        <v-button
          class="rounded-md sm:hidden w-full"
          :label="$t('components.createFreeAccount.button')"
          icon="user-line"
          :connotation="!isVonageBrand && 'cta'"
          :appearance="isVonageBrand ? 'filled' : 'outlined'"
          icon-trailing
        />
      </a>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { VButton } from '@vonage/vivid-vue';
import { SignUpCTAProps } from '@bifrost-dev-docs-mfe/common/types/compositeComponents/SignUpCTA';
import { getFullPathForPublicAssets, getFullPathForBrandedAssets } from '@/utils/url';
import useUserStore from '@/store/user';
import { isVonageBrand, VendorName } from '@/constants';

defineProps({
  data: {
    type: Object as PropType<SignUpCTAProps>,
    required: true,
  },
});

const user = useUserStore();
const isSignedIn = computed(() => user.info?.status === 'logged-in');
</script>

<style scoped lang="scss">
.sign-up-card {
  background: #1a1a1a;
}

.sign-up-card-text-title {
  color: var(--vvd-color-canvas);
}
.sign-up-card-text-description {
  color: var(--vvd-color-canvas);
}
.celebration-image {
  background-color: var(--vvd-color-canvas);
}
.signup-banner-bg {
  background: var(--dp-signup-banner-bg);
}
</style>
